import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Send, Eye, RefreshCw } from "lucide-react";
import api from "@/lib/api";

const STATUS_LABEL = {
  queued: "En file", prepared: "En file", scheduled: "Programmé", sent: "Envoyé au fournisseur",
  delivered: "Livré", deferred: "Différé", bounced: "Rejeté", complained: "Plainte",
  error: "Échec", failed: "Échec", opened: "Ouvert",
};

export default function ProjectCommunications({ projectId }) {
  const [items, setItems] = useState([]);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get(`/admin/communications/deliveries?project_id=${projectId}&limit=100`);
      setItems(data.items);
    } catch { toast.error("Journal indisponible"); }
  }, [projectId]);
  useEffect(() => { load(); }, [load]);

  const preview = async (id) => {
    try {
      const { data } = await api.get(`/admin/communications/deliveries/${id}/html`, { responseType: "text" });
      const w = window.open("", "_blank"); w.document.write(data); w.document.close();
    } catch { toast.error("Aperçu indisponible"); }
  };
  const resend = async (id) => {
    try { await api.post(`/email/deliveries/${id}/retry?force=true`); toast.success("Renvoi lancé"); setTimeout(load, 1500); }
    catch { toast.error("Renvoi impossible"); }
  };

  return (
    <div className="bg-white border border-black/10 rounded-rama-md p-5 md:p-6" data-testid="project-communications">
      <div className="flex items-center justify-between mb-4">
        <div>
          <div className="font-display text-xl text-anthracite">Communications du projet</div>
          <p className="text-xs text-ink-soft mt-1">Emails clients et alertes internes déclenchés par les événements de ce projet.</p>
        </div>
        <button data-testid="comms-refresh" onClick={load} className="text-xs text-bordeaux-700 hover:underline inline-flex items-center gap-1">
          <RefreshCw size={12} /> Rafraîchir
        </button>
      </div>
      {items.length === 0 ? (
        <p className="text-sm text-ink-soft">Aucun email envoyé pour ce projet.</p>
      ) : (
        <ul className="divide-y divide-black/5">
          {items.map((d) => (
            <li key={d.id} data-testid={`project-delivery-${d.id}`} className="py-3 flex flex-wrap items-center gap-x-4 gap-y-1">
              <span className="text-xs text-ink-soft w-[110px]">{new Date(d.created_at).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}</span>
              <span className="text-sm text-anthracite flex-1 min-w-[180px] truncate">{d.subject}</span>
              <span className="text-xs text-ink-soft truncate max-w-[180px]">{d.to} · {d.audience === "interne" ? "interne" : "client"}</span>
              <span className={`text-xs ${["error", "failed", "bounced"].includes(d.status) ? "text-bordeaux-700" : "text-ink-soft"}`}>
                {STATUS_LABEL[d.status] || d.status}
              </span>
              <span className="flex gap-2">
                <button data-testid={`project-delivery-preview-${d.id}`} onClick={() => preview(d.id)} className="text-ink-soft hover:text-bordeaux-700" title="Aperçu"><Eye size={14} /></button>
                <button data-testid={`project-delivery-resend-${d.id}`} onClick={() => resend(d.id)} className="text-ink-soft hover:text-bordeaux-700" title="Renvoyer"><Send size={14} /></button>
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
